import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    id: 1,
    name: "Fatima Ahmed",
    location: "Banjara Hills, Hyderabad",
    text: "The Ayatul Kursi painting is absolutely stunning. The gold leaf work catches the light beautifully, and it has become the centerpiece of our living room. Truly a blessing for our home.",
    rating: 5
  },
  {
    id: 2,
    name: "Mohammed Rizwan",
    location: "Jubilee Hills, Hyderabad",
    text: "I ordered a custom piece for my parents' anniversary. The attention to detail and the spiritual energy this artwork brings is remarkable. Worth every rupee.",
    rating: 5
  },
  {
    id: 3,
    name: "Sarah Khan",
    location: "Secunderabad",
    text: "Fast delivery and excellent packaging. The Bismillah calligraphy is even more beautiful in person. The artist's craftsmanship is evident in every stroke.",
    rating: 5
  }
];

const TestimonialCard = ({ testimonial, index, isInView }) => {
  return (
    <motion.div
      className="testimonial-card"
      initial={{ opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.5, delay: index * 0.15 }}
      data-testid={`testimonial-card-${testimonial.id}`}
    >
      {/* Quote Icon */}
      <div className="mb-4">
        <Quote className="text-[#D4AF37]/30" size={32} />
      </div>

      {/* Text */}
      <p className="font-manrope text-gray-300 leading-relaxed mb-6 italic">
        "{testimonial.text}"
      </p>

      {/* Rating */}
      <div className="flex gap-1 mb-4">
        {[...Array(testimonial.rating)].map((_, i) => (
          <Star key={i} className="text-[#D4AF37] fill-[#D4AF37]" size={16} />
        ))}
      </div>

      {/* Author */}
      <div>
        <p className="font-cinzel text-white">{testimonial.name}</p>
        <p className="font-manrope text-sm text-gray-500">{testimonial.location}</p>
      </div>
    </motion.div>
  );
};

const TestimonialsSection = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: "-100px" });

  return (
    <section className="py-24 relative" ref={sectionRef} data-testid="testimonials-section">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#0a0a0a] to-[#050505]" />

      <div className="section-container relative z-10">
        {/* Section Header */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <span className="font-manrope text-sm text-[#D4AF37] uppercase tracking-widest mb-4 block">
            Testimonials
          </span>
          <h2 className="font-cinzel text-section-title text-gold-gradient mb-4">
            What Our Collectors Say
          </h2>
          <div className="gold-line mx-auto" />
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard
              key={testimonial.id}
              testimonial={testimonial}
              index={index}
              isInView={isInView}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
